export interface AreaRecorte {
  x: number;
  y: number;
  width: number;
  height: number;
}

// GIF fica de fora de proposito: o canvas so consegue exportar o primeiro
// quadro, entao recortar um GIF animado apagaria a animacao sem avisar.
export const TIPOS_RECORTAVEIS = ['image/jpeg', 'image/png', 'image/webp'];

export const podeRecortar = (tipo?: string | null): boolean =>
  Boolean(tipo) && TIPOS_RECORTAVEIS.includes(tipo as string);

// O react-easy-crop devolve a area em pixels do arquivo original, mas com
// fracao e, por arredondamento, as vezes um pixel fora da imagem. Passar isso
// direto para o canvas gera borda transparente ou drawImage sem efeito.
export const normalizarRecorte = (
  area: AreaRecorte,
  larguraNatural: number,
  alturaNatural: number,
): AreaRecorte => {
  const limite = (valor: number, maximo: number) =>
    Math.min(Math.max(Math.round(valor), 0), maximo);

  const x = limite(area.x, Math.max(0, larguraNatural - 1));
  const y = limite(area.y, Math.max(0, alturaNatural - 1));

  return {
    x,
    y,
    width: Math.max(1, limite(area.width, larguraNatural - x)),
    height: Math.max(1, limite(area.height, alturaNatural - y)),
  };
};

// PNG e mantido para nao perder transparencia — logo de conta costuma depender
// disso. O resto sai como JPEG, que e menor.
export const tipoDeSaida = (tipoOriginal?: string | null): string =>
  tipoOriginal === 'image/png' ? 'image/png' : 'image/jpeg';

export const nomeDeSaida = (nomeOriginal: string, tipoSaida: string): string => {
  const extensao = tipoSaida === 'image/png' ? 'png' : 'jpg';
  const base = nomeOriginal.replace(/\.[^./\\]+$/, '').trim();

  return `${base || 'imagem'}.${extensao}`;
};

// O react-dropzone define `path` como somente leitura no File que entrega, entao
// Object.assign quebra. O arquivo que sai do recorte, por outro lado, nasce sem
// `path` — e sem ele a legenda do preview some.
export const garantirPath = <T extends File>(arquivo: T): T & {path: string} => {
  const comPath = arquivo as T & {path?: string};

  if (!comPath.path) {
    Object.defineProperty(arquivo, 'path', {
      value: arquivo.name,
      enumerable: true,
      configurable: true,
    });
  }

  return arquivo as T & {path: string};
};

export const proporcaoValida = (proporcao?: number | null): number | undefined =>
  typeof proporcao === 'number' && Number.isFinite(proporcao) && proporcao > 0 ? proporcao : undefined;
